import { apiCall } from './api';
import { INVITE_CONTENT, INVITE_CONTENT_DETAILS, INVITE_CONTENT_STATUS, INVITE_CONTENT_STATS } from '../config/api';

// Get all Invite Content items
export const getInviteContent = async (params = {}) => {
  try {
    console.log('🚀 getInviteContent called with params:', params);
    console.log('🔗 Making API call to:', INVITE_CONTENT);
    
    const response = await apiCall(INVITE_CONTENT, {
      method: 'GET',
      params
    });
    
    console.log('📡 API Response from getInviteContent:', response);
    return response;
  } catch (error) {
    console.error('❌ Error in getInviteContent:', error);
    throw error;
  }
};

// Get Invite Content item by ID
export const getInviteContentById = async (contentId) => {
  try {
    const endpoint = INVITE_CONTENT_DETAILS.replace('{id}', contentId);
    const response = await apiCall(endpoint, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Invite Content item:', error);
    throw error;
  }
};

// Create new Invite Content item
export const createInviteContent = async (contentData) => {
  try {
    console.log('🚀 createInviteContent called with data:', contentData);
    console.log('🔗 Making API call to:', INVITE_CONTENT);
    
    const response = await apiCall(INVITE_CONTENT, {
      method: 'POST',
      data: contentData
    });
    
    console.log('📡 API Response from createInviteContent:', response);
    return response;
  } catch (error) {
    console.error('❌ Error creating Invite Content item:', error);
    throw error;
  }
};

// Update Invite Content item
export const updateInviteContent = async (contentId, contentData) => {
  try {
    const endpoint = INVITE_CONTENT_DETAILS.replace('{id}', contentId);
    console.log('🚀 updateInviteContent called with ID:', contentId, 'and data:', contentData);
    console.log('🔗 Making API call to:', endpoint);
    
    const response = await apiCall(endpoint, {
      method: 'PUT',
      data: contentData
    });
    
    console.log('📡 API Response from updateInviteContent:', response);
    return response;
  } catch (error) {
    console.error('❌ Error updating Invite Content item:', error);
    throw error;
  }
};

// Update Invite Content status
export const updateInviteContentStatus = async (contentId, status) => {
  try {
    const endpoint = INVITE_CONTENT_STATUS.replace('{id}', contentId);
    const response = await apiCall(endpoint, {
      method: 'PATCH',
      data: { status }
    });
    return response;
  } catch (error) {
    console.error('Error updating Invite Content status:', error);
    throw error;
  }
};

// Get Invite Content statistics
export const getInviteContentStats = async () => {
  try {
    const response = await apiCall(INVITE_CONTENT_STATS, {
      method: 'GET'
    });
    return response;
  } catch (error) {
    console.error('Error fetching Invite Content stats:', error);
    throw error;
  }
};
